import { useCallback } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import ProjectInvitation, { ProjectInvitationJSON } from '../models/projectInvitation';
import useProjectMembersSystem from '../system/useProjectMembersSystem';
import { QueryKeys } from './keysAndFilters';

export type UseDeleteProjectInvitationMutationParams = {
	projectID: number;
	onSuccess?: ( invitation: ProjectInvitation ) => void,
	onError?: ( error: unknown ) => void
};

const useDeleteProjectInvitationMutation = ( {
	projectID, onSuccess: onMutationSuccess, onError: onMutationError
}: UseDeleteProjectInvitationMutationParams ) => {
	const system = useProjectMembersSystem();
	const queryClient = useQueryClient();

	const onSuccess = useCallback( ( _data: ProjectInvitationJSON, invitation: ProjectInvitation ) => {
		queryClient.invalidateQueries( {
			queryKey: QueryKeys.forProjectInvitations( { projectID } ),
			refetchType: 'active'
		} );

		onMutationSuccess?.( invitation );
	}, [ onMutationSuccess, projectID, queryClient ] );

	return useMutation(
		( invitation: ProjectInvitation ) => (
			system.deleteProjectInvitation( { invitationID: invitation.id } )
		),
		{ onSuccess, onError: onMutationError }
	);
};

export default useDeleteProjectInvitationMutation;
